import React from 'react'
import { connect } from "react-redux";
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import PurchaseStyles from './PurchaseStyles';
import useAuth  from '../../hooks/useAuth';

const PurchaseOrderDetailGeneral = ({ classes, ...props }) => {
    const { isOCA, isOCV, isOCVA } = useAuth(props.orderDetail);
    return (
        <Container>
            <Grid item xs={12} className={classes.alignCenter}>
                <Grid item xs={12} className={classes.alignCenter}>
                    <h5>Orden de compra para automóviles e información para placas</h5>
                </Grid>
                <Grid container className={classes.containerWithBorderRound}>
                    <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Datos</h5>
                    </Grid>
                    {/*<Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Proveedor</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignRight}>
                            <h5>{props.orderDetail.supplierName}</h5>
                        </Grid>
    </Grid>*/}
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Marca / Modelo / Versión /Año</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignRight}>
                            <h5>{props.orderDetail.carBrand} / {props.orderDetail.carModel} / {props.orderDetail.carVersion} / {props.orderDetail.carYear}</h5>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerWithBorderRound}>
                    <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Información para la factura</h5>
                    </Grid>
                    <Grid item xs={12} className={classes.alignCenter}>
                        <h5>Element Fleet Management Corporation México SA de CV</h5>
                        <h5>RFC: EFM150724B12</h5>
                        <h5>AV. VÍA MAGNA Número Exterior 19 MZ II LT 5 Número Interior Piso 5, Área 4</h5>
                        <h5>LA HERRADURA SECCIÓN III</h5>
                        <h5>HUIXQUILICAN, MÉXICO, C.P. 52784</h5>
                    </Grid>
                </Grid>
                {!isOCA && <Grid container className={classes.containerWithBorderRound}>
                    <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Información Gestorías</h5>
                    </Grid>
                    <Grid item xs={12} className={classes.alignCenter}>
                        <h5>Placas: {props.orderDetail.platesRequired ? 'Si' : 'No'}</h5>
                        <h5>Estado: {props.orderDetail.licensePlatesState ? props.orderDetail.licensePlatesState : '-'}</h5>
                        <h5>Verificación: {props.orderDetail.verificationRequired ? 'Si' : 'No'}</h5>
                    </Grid>
                </Grid>}
                {!isOCA && <Grid item xs={12} className={classes.gridColor2}>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Forma de entrega</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignRight}>
                            <h5>{props.orderDetail.deliveryForm ? props.orderDetail.deliveryForm : '-'}</h5>
                        </Grid>
                    </Grid>
                </Grid>}
                {!isOCA && <Grid item xs={12} className={classes.gridColorDefault}>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Información de seguro</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignRight}>
                            <h5>Seguro: {props.orderDetail.insuranceRequired ? 'Si' : 'No'}</h5>
                        </Grid>
                    </Grid>
                </Grid>}
            </Grid>
        </Container>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language,
    navList: state.NavigationReducer.routeList
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PurchaseStyles)(PurchaseOrderDetailGeneral))